import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "well col-lg-8",
  id: "3d_canv"
}
const _hoisted_2 = { class: "well col-lg-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { initFlowbite } from 'flowbite';
import { onMounted } from 'vue';
import { Person3d } from '../components/Models/Person3d'
import { ref } from 'vue';
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls';




export default /*#__PURE__*/_defineComponent({
  __name: 'Model3D',
  setup(__props) {




let persona = {} as Person3d;
const canvas = ref(null as HTMLCanvasElement)
//import dolore from '@/src/JavaScript/dolore.js';
// Export the Vue component
onMounted(() => {
    initThree()
    loadModel()

});


function initThree() {
    persona.scene = new THREE.Scene();
    persona.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    persona.camera.position.z = 15;
    persona.camera.position.y = 3;
    persona.camera.position.x = 2;
    persona.renderer = new THREE.WebGLRenderer({ canvas: this.$refs.canvas, antialias: true });
    persona.renderer.shadowMap.enabled = true;
    persona.scene.background = new THREE.Color(this.BACKGROUND_COLOR);
    persona.scene.fog = new THREE.Fog(this.BACKGROUND_COLOR, 1, 100);
    persona.renderer.setSize(window.innerWidth, window.innerHeight);

}

function loadModel() {
    const loader = new GLTFLoader();
    loader.load('@/assets/images/Woman_3D.glb', (gltf) => {
        this.model = gltf.scene;
        this.model.traverse(o => {
            if (this.isMesh) {
                //console.log(this.isMesh);
                o.castShadow = true;
                o.receiveShadow = true;
                this.INITIAL_MAP.push({ childID: o.name, mtl: this.INITIAL_MTL });
                this.mesh_objects.push(o);
                //console.log(this.mesh_objects);
                this.selectedPlaces.push({ name: o.name, activated: false, hovered: false, dolore: this.init.nome_dolore });
                //this.initialRotation();
                //this.clickable = true;
            }
        });
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("canvas", {
      ref_key: "canvas",
      ref: canvas,
      id: "c",
      class: "modalCanvass",
      style: {"border":"2px solid"}
    }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg btn-line btn-block",
        style: {"text-align":"left"},
        "on:Click": _cache[0] || (_cache[0] = ($event: any) => {_ctx.changeSelectedColor('#ffffff');})
      }, " Nessun dolore", 32),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg btn-line btn-block",
        style: {"text-align":"left"},
        "on:Click": _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeSelectedColor('#00ff00')))
      }, " Dolore lieve", 32),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg btn-line btn-block",
        style: {"text-align":"left"},
        "on:Click": _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeSelectedColor('#2323d2')))
      }, " Dolore moderato", 32),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg btn-line btn-block",
        style: {"text-align":"left"},
        "on:Click": _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeSelectedColor('#8a2070')))
      }, " Dolore intenso", 32),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg btn-line btn-block",
        style: {"text-align":"left"},
        "on:Click": _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeSelectedColor('#7a0026')))
      }, " Dolore forte", 32),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-lg btn-line btn-block",
        style: {"text-align":"left"},
        "on:Click": _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeSelectedColor('#ff0000')))
      }, " Dolore molto forte", 32),
      _hoisted_3
    ])
  ]))
}
}

})